module.exports = __webpack_public_path__ + "img/IMG_2368_L_Black_MockedUp.4a078100.jpg";